import { render } from "./RepSumTestsuit.vue?vue&type=template&id=e33dd25c"
import script from "./RepSumTestsuit.vue?vue&type=script&lang=js"
export * from "./RepSumTestsuit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__